module.exports = __webpack_public_path__ + "static/media/soap-for-hands.d9c692cc.svg";